<template>
  <el-dialog
    title="初审结果"
    :visible.sync="dialogVisible"
    width="60%"
    center
    :before-close="onClickCancle"
    :close-on-click-modal="false">
    <el-form ref="form" :model="projectData" :rules="rules">
      <div style="margin-top: 8px;">（1）发明专利
        <el-form-item prop="invent">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.invent" class="input_text" @input="(val)=>{projectData.invent = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项（附件编号
        <el-form-item prop="adjunct1">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct1" class="input_text"></el-input>
        </el-form-item>
        ），满1年以上的
        <el-form-item prop="deadline1">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline1" class="input_text" @input="(val)=>{projectData.deadline1 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项；
      </div>
      <div>（2）实用新型专利
        <el-form-item prop="nowtype">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.nowtype" class="input_text" @input="(val)=>{projectData.nowtype = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项（附件编号
        <el-form-item prop="adjunct2">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct2" class="input_text"></el-input>
        </el-form-item>
        ），满1年以上的
        <el-form-item prop="deadline2">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline2" class="input_text" @input="(val)=>{projectData.deadline2 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项；
      </div>
      <div>（3）编制标准
        <el-form-item prop="standard">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.standard" class="input_text" @input="(val)=>{projectData.standard = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项，其中国家（行业）标准
        <el-form-item prop="countrystandard">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.countrystandard" class="input_text" @input="(val)=>{projectData.countrystandard = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项（附件编号
        <el-form-item prop="adjunct31">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct31" class="input_text"></el-input>
        </el-form-item>
        ），满一年以上的
        <el-form-item prop="deadline31">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline31" class="input_text" @input="(val)=>{projectData.deadline31 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项；地方标准
        <el-form-item prop="spacestandard">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.spacestandard" class="input_text" @input="(val)=>{projectData.spacestandard = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项（附件编号
        <el-form-item prop="adjunct32">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct32" class="input_text"></el-input>
        </el-form-item>
        ），满一年以上的
        <el-form-item prop="deadline32">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline32" class="input_text" @input="(val)=>{projectData.deadline32 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项；
      </div>
      <div>（4）软件著作权
        <el-form-item prop="copyright">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.copyright" class="input_text" @input="(val)=>{projectData.copyright = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项（附件编号
        <el-form-item prop="adjunct4">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct4" class="input_text"></el-input>
        </el-form-item>
        ），满1年以上的
        <el-form-item prop="deadline4">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline4" class="input_text" @input="(val)=>{projectData.deadline4 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项；
      </div>
      <div>（5）SCI论文
        <el-form-item prop="scipaper">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.scipaper" class="input_text" @input="(val)=>{projectData.scipaper = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇（附件编号
        <el-form-item prop="adjunctsci">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctsci" class="input_text"></el-input>
        </el-form-item>
        ），满1年以上的
        <el-form-item prop="deadline5">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline5" class="input_text" @input="(val)=>{projectData.deadline5 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇；
      </div>
      <div>（6）EI论文
        <el-form-item prop="eipaper">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.eipaper" class="input_text" @input="(val)=>{projectData.eipaper = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇（附件编号
        <el-form-item prop="adjunctei">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctei" class="input_text"></el-input>
        </el-form-item>
        ），满1年以上的
        <el-form-item prop="deadline6">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline6" class="input_text" @input="(val)=>{projectData.deadline6 = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇；
      </div>
      <div>（7）核心期刊论文
        <el-form-item prop="corejournal">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.corejournal" class="input_text" @input="(val)=>{projectData.corejournal = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇（附件编号
        <el-form-item prop="adjunctcore">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctcore" class="input_text"></el-input>
        </el-form-item>
        ），其中中文核心
        <el-form-item prop="chinesecore">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.chinesecore" class="input_text" @input="(val)=>{projectData.chinesecore = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇，科技核心
        <el-form-item prop="sciencecore">
          <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.sciencecore" class="input_text" @input="(val)=>{projectData.sciencecore = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        篇；
      </div>
      <div>（8）近三年主要经济效益
        <el-form-item prop="benefit">
          <el-input :readonly="isDisabled" size="small" style="width: 100px" v-model="projectData.benefit" class="input_text" @input="(val)=>{projectData.benefit = limitDecimalInputWithDigit(val, 4)}"></el-input>
        </el-form-item>
        万元（旁证材料见附件编号
        <el-form-item prop="adjunctbenefit">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctbenefit" class="input_text"></el-input>
        </el-form-item>
        ）；
      </div>
      <div>（9）已在
        <el-form-item prop="promotion">
          <el-input :readonly="isDisabled" size="small" style="width: 100px" v-model="projectData.promotion" class="input_text"></el-input>
        </el-form-item>
        范围内推广应用，并产生了显著的社会效益（旁证材料见附件编号
        <el-form-item prop="adjunctpromotion">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctpromotion" class="input_text"></el-input>
        </el-form-item>
        ）；
      </div>
      <div>（10）其它
        <el-form-item prop="others">
          <el-input :readonly="isDisabled" size="small" style="width: 100px" v-model="projectData.others" class="input_text" @input="(val)=>{projectData.others = val.replace(/[^\d:]/g, '')}"></el-input>
        </el-form-item>
        项（附件编号
        <el-form-item prop="adjunct5">
          <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct5" class="input_text"></el-input>
        </el-form-item>
        ）。
      </div>
      <div><br/>初审意见：</div>
      <el-form-item prop="opinion" style="width: 100%">
        <el-input size="small" style="width: 100%;margin-top: 10px;" type="textarea" :autosize="{minRows:6}" v-model="projectData.opinion"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="onClickCancle">取 消</el-button>
    <el-button type="primary" @click="onClickConfirm">确 定</el-button>
  </span>
  </el-dialog>

</template>

<script>
import utils from "../../js/utils";

export default {
  name: "fundAuidt_publicDialog",
  data() {
    return {
      projectData: {},
      isDisabled: false,
      rules: {}
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    auditOrRead: {
      type: String,
      default: ''
    },
    pbcid: '',
    isRefresh: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    getData() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectopinion',
        params: {
          pbcid: this.pbcid,
          opiniontype: 1,
        }
      }).then((res) => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          if (resp.data !== null) {
            this.projectData = resp.data
          }
        } else {
          this.showFailMsg(resp.message);
        }
      })

    },
    onClickConfirm() {
      if (this.projectData.oid !== undefined && this.projectData.oid !== '' && this.projectData.oid !== null) {
        this.onUpdate()
      } else {
        this.onAdd()
      }
    },
    onAdd() {
      this.projectData.opiniontype = 1
      this.projectData.pbcid = this.pbcid
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/admin/addcheckopinion',
        data: this.projectData
      }).then((res) => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message);
          this.onClickCancle()
          this.$emit('update:isRefresh', 'true')
        } else {
          this.showFailMsg(resp.message);
        }
      })
    },
    onUpdate() {
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/admin/updatecheckopinion',
        data: this.projectData
      }).then((res) => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message);
          this.onClickCancle()
          this.$emit('update:isRefresh', 'true')
        } else {
          this.showFailMsg(resp.message);
        }
      })
    },
    onClickCancle() {
      this.projectData = {
        pbcid: Number(sessionStorage.getItem('pbcid')),
      },
        this.$emit('update:dialogVisible', false)
    },
  },
  created() {
    this.getData()
  }
}
</script>

<style scoped>
/deep/ .input_text .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  padding: 0 3px;
  height: 16px;
  text-align: center;
}

.el-form-item {
  display: inline-block;
  margin-bottom: 0;
}

/deep/ .el-form-item__content {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/fundAuidt_publicDialog.vue